import React, { useLayoutEffect, useRef } from 'react';
import SunEditor from 'suneditor-react';
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link,
  video,
  audio,
} from 'suneditor/src/plugins';
import SunEditorCore from 'suneditor/src/lib/core';
import { Space } from 'antd';

import 'suneditor/dist/css/suneditor.min.css';

const getSelectionText = () => {
  let text = '';

  if (window && document) {
    // @ts-ignore
    text = window.getSelection().toString();
    // @ts-ignore
  } else if (document.selection && document.selection.type != 'Control') {
    // @ts-ignore
    text = document.selection.createRange().text;
  }

  return text;
};

const tl = {
  name: 'distinction',
  display: 'submenu',
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  add: function (core: any, targetElement: any): any {
    const listDiv = this.setSubmenu.call(core);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    listDiv
      .querySelectorAll('.se-btn-list')
      .forEach(function (btn: {
        addEventListener: (arg0: string, arg1: (e: any) => void) => void;
      }) {
        btn.addEventListener('click', self.onClick.bind(core));
      });
    core.initMenuTarget(this.name, targetElement, listDiv);
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setSubmenu: function () {
    // @ts-ignore
    const listDiv = this.util.createElement('DIV');
    listDiv.className = 'se-submenu se-list-layer';
    listDiv.innerHTML = `<div class="se-list-inner se-list-font-size">
            <ul class="se-list-basic">
                <li><button type="button" class="se-btn-list" value="Wyróżnienie do lewej" data-align="left">Wyróżnienie do lewej</button></li>
                <li><button type="button" class="se-btn-list" value="Wyróżenienie do prawej" data-align="right">Wyróżenienie do prawej</button></li>
                <li><button type="button" class="se-btn-list" value="Wyróżenienie centralne" data-align="full">Wyróżenienie centralne</button></li>
            </ul>
        </div>`;
    return listDiv;
  },
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onClick: function (e) {
    const alignment = e.target.getAttribute('data-align');
    const value =
      getSelectionText() !== '' ? getSelectionText() : e.target.value;
    // @ts-ignore
    const node = this.util.createElement('div');

    const quoteMarkText = document.createElement('div');

    if (alignment === 'full') {
      quoteMarkText.className = 'quoteTextBig';
    } else {
      quoteMarkText.className = 'quoteText';
    }

    quoteMarkText.innerHTML = value;

    if (alignment === 'left') {
      // @ts-ignore
      this.util.addClass(node, 'quoteGL');
    }
    if (alignment === 'right') {
      // @ts-ignore
      this.util.addClass(node, 'quoteG');
    }
    if (alignment === 'full') {
      // @ts-ignore
      this.util.addClass(node, 'quoteGB');
    }
    node.appendChild(quoteMarkText);
    // @ts-ignore
    this.insertNode(node);
    // @ts-ignore
    const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
    node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);
    // @ts-ignore
    this.submenuOff();
  },
};

const TextEditor = ({
  onChange,
  initialValue,
}: {
  onChange: (e: any) => void;
  initialValue?: string;
  disableGallery?: boolean;
}): JSX.Element => {
  const editor = useRef<SunEditorCore>();
  // const [isGalleryVisible, setGalleryVisibility] = useState(false);

  const getSunEditorInstance = (sunEditor: SunEditorCore) => {
    editor.current = sunEditor;
  };

  // regex replace <p><br></p> to empty string
  const handleOnChange = (content: string) => {
    onChange(content.replace(/<p><br><\/p>/g, ''));
  };

  useLayoutEffect(() => {
    if (initialValue) {
      editor.current?.setContents(initialValue);
    }
  }, [initialValue]);
  /*
  const addImage = (file: any | Element) => {
    const elementHtml = `<img src=\"https://static.nawozy.org.pl/file/${file[0].name}\" alt=""/>`;
    // @ts-ignore
    editor.current.insertHTML(file);
    message.success('Pozytywnie dodano obrazek do tekstu');
    // setGalleryVisibility(false);
  };*/

  return (
    <>
      {/*    {isGalleryVisible && (
        <GalleryDrawer
          closeDrawer={() => setGalleryVisibility(false)}
          onImageClick={addImage}
          addUrl
        />
      )}*/}
      {/*<GalleryUpload fileList={fileList} setFileList={addImage}/>*/}
      <Space direction="vertical" style={{ width: '100%' }}>
        {/*   {!disableGallery && (
          <Button onClick={() => setGalleryVisibility(true)}>
            Galeria zdjęć
          </Button>
        )}*/}
        <div className="text-editor-wrapper">
          <SunEditor
            getSunEditorInstance={getSunEditorInstance}
            lang="pl"
            defaultValue={initialValue}
            onChange={handleOnChange}
            width="100%"
            height="350px"
            setOptions={{
              height: '300px',
              defaultStyle:
                "font-size:18px;font-family: 'Roboto Regular', sans-serif;",
              plugins: [
                align,
                font,
                fontColor,
                fontSize,
                formatBlock,
                hiliteColor,
                horizontalRule,
                list,
                paragraphStyle,
                table,
                template,
                textStyle,
                image,
                link,
                video,
                audio,
                tl,
              ],
              buttonList: [
                ['font', 'fontSize', 'formatBlock'],
                ['paragraphStyle', 'blockquote'],
                [
                  'bold',
                  'underline',
                  'italic',
                  'strike',
                  'subscript',
                  'superscript',
                ],
                [
                  'fontColor',
                  'hiliteColor',
                  {
                    name: 'distinction',
                    dataCommand: 'distinction',
                    title: 'Wyróżnienia',
                    dataDisplay: 'submenu',
                    innerHTML:
                      '<span id="text-editor-text-distinction">T</span>',
                  },
                ],
                ['removeFormat'],
                '/',
                ['outdent', 'indent'],
                ['align', 'horizontalRule', 'list'],
                ['table', 'link', 'image', 'video', 'audio'],
                ['fullScreen', 'showBlocks', 'codeView'],
                ['undo', 'redo'],
                /*    ['preview', 'print'],*/
              ],
              formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
              font: ['Roboto Regular', 'Roboto Medium', 'Roboto Bold'],
              imageFileInput: false,
              imageUrlInput: false,
            }}
          />
        </div>
      </Space>
    </>
  );
};
export default TextEditor;
